/**
 * descption
 * author: CarloHsu TGFE
 * Date: 2019-05-13
 * Time: 14:48
 *
 */

import {request } from '../http';
import domain from '../domain';

var amazonService = function() {
    if (domain.env === 'online') {
        this.domain = "//aws-test.51tiangou.com";
    } else {
        this.domain = "//dres3pub60.execute-api.cn-north-1.amazonaws.com.cn";
    }
};
// 查询券列表
amazonService.prototype.amazonCouponList = function(params) {
    var that = this;
    params.type = 'POST';
    params.headers = {"x-api-key":'sKoORrwA3S41zSw630Mvh2lnGupgE13CaPylI2No'};
    params.xhrFields = {
        withCredentials: false
    };
    that._serviceAjaxCom("/beta/getcoupons", params);
};


amazonService.prototype._serviceAjaxCom = function(url, params) {
    params.url = this.domain + url;
    request(params);
};

export default new amazonService();